<template>
  <base-dialog v-model="visible" width="520px" class="publish-dialog" type="warning" title="商城发布">
    <div class="publish-dialog__content">
      <div class="my-6 text-center text-black text-16">有未保存的配置，您希望：</div>
      <div class="flex items-center justify-end py-4 px-5 gap-5">
        <button class="normal-btn" @click.stop="handleCancel">不保存发布</button>
        <button class="remove-btn" :class="{ 'opacity-70': loading }" @click.stop="handleSave">
          <i v-if="loading" class="el-icon-loading"></i>
          保存并发布
        </button>
      </div>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from "~/components/base/baseDialog.vue";
export default {
  name: 'PublishDialog',
  components: {BaseDialog},
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      visible: false
    }
  },
  methods: {
    init() {
      this.visible = true
    },
    close() {
      this.visible = false
    },
    handleCancel() {
      this.visible = false
      this.$emit('publish')
    },
    handleSave() {
      this.$emit('save-publish')
    }
  }
}
</script>

<style lang="less">
.publish-dialog {
  &__content {
    .normal-btn {
      background-color: white;
      line-height: 32px;
      padding: 0 10px;
      color: black;
      border: 1px solid #dedede;
      border-radius: 2px;
    }
    .remove-btn {
      background-color: @danger-color;
      line-height: 32px;
      padding: 0 10px;
      color: white;
      border: 1px solid @danger-color;
      border-radius: 2px;
    }
  }
}
</style>
